import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDownLeftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M7.117 8.826a1 1 0 0 1 1.09.217l2.668 2.668 4.918-4.918a1 1 0 1 1 1.414 1.414l-4.918 4.918 2.668 2.668a1 1 0 0 1-.707 1.707H7.5a1 1 0 0 1-1-1V9.75a1 1 0 0 1 .617-.924'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDownLeftLine)
export default ForwardRef
